/**
 * Module-level modal stack so each open modal can ask "am I the topmost?"
 * before handling document-level events (ESC, arrow keys). Without this,
 * an underlying InningDetailModal can intercept ESC meant for a stacked
 * PlayerModal / ZoomModal — a Codex Pass-3 finding.
 *
 * Token is just an opaque object; identity is the contract.
 */
const stack: object[] = [];

export function pushModal(token: object): void {
  stack.push(token);
}

export function popModal(token: object): void {
  const i = stack.lastIndexOf(token);
  if (i !== -1) stack.splice(i, 1);
}

export function isTopModal(token: object): boolean {
  return stack.length > 0 && stack[stack.length - 1] === token;
}
